import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { PublicComponent } from './public/public.component';
import { SecureComponent } from './secure/secure.component';
import { NotFoundComponent } from './_shared/not-found/not-found.component';
import { CallbackComponent } from './_shared/callback/callback.component';
import { AuthGuardService } from './_services/auth/auth.guard.service';

const appRoutes: Routes = [

  { path: '', redirectTo: 'public', pathMatch: 'full' },
  {
      path: '', children: [
          { path: '', component: PublicComponent },
          { path: '', component: SecureComponent, canActivate: [AuthGuardService] }]
  },
  { path: 'callback', component: CallbackComponent },
  { path: '**', component: NotFoundComponent }
];

@NgModule({
  imports: [
      RouterModule.forRoot(appRoutes)
  ],
  exports: [
      RouterModule
  ],
  providers: [
      AuthGuardService
  ]
})
export class AppRoutingModule { }
